import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class ActivityService {
    // Get all 
    static async getAllActivities(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.ACTIVITY; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch activities.');
            return [];
        }
    }

    // Create
    static async addNewActivity(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.ACTIVITY; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Activity added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new activity.');
        }
    }

    // Get by ID
    static async getActivityById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ACTIVITY}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch activity by ID');
        }
    }

    // Update 
    static async updateActivityById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ACTIVITY}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Activity updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update activity.');
        }
    }

    // Delete 
    static async deleteActivity(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ACTIVITY}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete activity.');
            }
        } catch (error) {
            console.error('Error deleting activity:', error);
            throw error;
        }
    }

    // Delete Multiple 
    static async deleteManyActivities(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.ACTIVITY}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
